import Accounting from "accounting";

import SettingActions from "../actions/SettingActions";

import CurrencyStore from "../stores/CurrencyStore";

const formats = [
	{name: "%s-%v", displayName: "$-50.00", isDefault: true},
	{name: "-%s%v", displayName: "-$50.00"},
	{name: "%s(%v)", displayName: "$(50.00)"},
	{name: "(%s%v)", displayName: "($50.00)"}
];

// AccountingHelper
export default
{
	formats,

	async setFormat(setFormat, initialize)
	{
		let format = Accounting.settings.currency.format;
		let defaultFormat = "%s%v";
		if (typeof format === "string")
		{
			defaultFormat = format;
		}
		format = {
			pos: defaultFormat,
			zero: defaultFormat,
			neg: setFormat
		};
		if (!initialize)
		{
			await SettingActions.updateUserProfile("Format", setFormat);
		}
		Accounting.settings.currency.format = format;
	},

	getNumberDecimals(currencyId)
	{
		let numberDecimals = null;
		const currency = CurrencyStore.getCurrencyDefinitionByCurrencyId(currencyId);
		if (currency)
		{
			numberDecimals = currency.numberDecimals;
		}
		if (numberDecimals !== 0 && !numberDecimals)
		{
			numberDecimals = 2;
		}

		return numberDecimals;
	},

	formatMoney(amount, currencyId, numberDecimals)
	{
		let formattedAmount = null;
		if (numberDecimals !== 0 && !numberDecimals && !!currencyId)
		{
			numberDecimals = this.getNumberDecimals(currencyId);
		}

		if (currencyId)
		{
			var currencySettings = CurrencyStore.getCurrency(currencyId);
			if (currencySettings)
			{
				var settings = {};
				if (currencySettings.symbol) {
					settings.symbol = currencySettings.symbol;
				}
				if (currencySettings.format) {
					settings.format = currencySettings.format;
				}
				if (numberDecimals === 0 || !!numberDecimals) {
					settings.precision = numberDecimals;
				}
				formattedAmount = Accounting.formatMoney(amount, settings);
			}
			// TODO BUG-250: figure out the issue here, seems that sometimes this loads before we have currency info
		}

		if (!formattedAmount)
		{
			formattedAmount = Accounting.formatMoney(amount);
		}

		return formattedAmount;
	},

	getExchangeRate(sourceCurrencyId, targetCurrencyId)
	{
		let fromRate = 1.0;
		let toRate = 1.0;
		if (sourceCurrencyId)
		{
			const currencyDefinition = CurrencyStore.getCurrencyDefinitionByCurrencyId(sourceCurrencyId);
			if (currencyDefinition)
			{
				fromRate = currencyDefinition.currentRate;
			}
		}

		if (targetCurrencyId)
		{
			const currencyDefinition = CurrencyStore.getCurrencyDefinitionByCurrencyId(targetCurrencyId);
			if (currencyDefinition)
			{
				toRate = currencyDefinition.currentRate;
			}
		}

		return toRate / fromRate;
	},

	convertAmount(amount, exchangeRate)
	{
		return amount * exchangeRate;
	},

	toFixed(amount, decimals)
	{
		return Accounting.toFixed(amount, decimals);
	}
};



// WEBPACK FOOTER //
// ./Components/utils/AccountingHelper.jsx